import React, { useState, useEffect } from 'react'
import { BigCardsGrid, GraphCard, TopRight } from '../../../styles/dashboard/graphStyle'
import { InputField, GridPaddedSpace, FlexedBtn } from '../../../styles/reusable/index'
import axios from 'axios'
import { Button } from '../../../styles/reusable'
import { Link } from 'react-router-dom'
import { ClipLoader } from 'react-spinners'
import Alert from '../../reusable/alert'

interface PropsArgs {
  mode: string
  active: string
  setActive: any
  setMode: any
  model: any
  activeVendor: string
  vendors: Array<[]>
}

const Collection = ({ mode, active, setActive, setMode, model, vendors, activeVendor }: PropsArgs) => {
  const loggedAdmin = localStorage.getItem('tks') || '{}'

  // States
  const [vendorName, setVendorName] = useState('')
  const [genericFee, setGenericFee] = useState('')
  const [genericUSSDFee, setGenericUSSDFee] = useState('')
  const [mongoroUSSDFee, setMongoroUSSDFee] = useState('')
  const [mongoroFee, setMongoroFee] = useState('')
  const [onProcess, setOnProcess] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const basicPayload = {
    vendorName,
    feePercent: genericFee,
    feeUssd: genericUSSDFee,
    mongoroFeePercent: mongoroFee,
    mongoroFeeUssd: mongoroUSSDFee
  }

  useEffect(() => {
    setVendorName(activeVendor)
  }, [activeVendor])

  useEffect(() => {
    if (model && Object.keys(model).length > 0) {
      setVendorName(model.vendorName)
      setGenericFee(model.feePercent)
      setGenericUSSDFee(model.feeUssd)
      setMongoroFee(model.mongoroFeePercent)
      setMongoroUSSDFee(model.mongoroFeeUssd)
    }
  }, [model])

  const editModel = () => {
    setOnProcess(true)
    axios.post(`${process.env.REACT_APP_BASE_URL}/super/admin/business/collection`, basicPayload, {
      headers: {
        'x-token': `${loggedAdmin}`
      }
    }).then((res) => {
      setSuccess(true)
      setOnProcess(false)
    }).catch((err) => {
      setOnProcess(false)
      setError(err.response.data.message)
      setTimeout(() => {
        setError('')
      }, 4000)
    })
  }

  return (
        <>
            <GraphCard margin='0 0 2rem 0'>
                <TopRight>
                    <Button
                        bg='#EFF3BE'
                        color='#ffab01'
                        onClick={() => {
                          mode === 'edit' && active === 'collection'
                            ? setMode('view')
                            : setMode('edit')
                          setActive('collection')
                        }
                            }
                    >
                        {mode === 'edit' && active === 'collection' ? 'View' : 'Edit'}
                    </Button>
                </TopRight>
                <BigCardsGrid>
                    <GridPaddedSpace>
                        <h3>Collection</h3>
                        <div>
                            <InputField>
                                <legend>Vendor name</legend>
                                <select
                                    onChange={(e) => { setVendorName(e.target.value) }}
                                    value={vendorName}
                                >
                                    {
                                        vendors && vendors.length > 0
                                          ? vendors.map((item: any, index) => (
                                                <option key={index}>
                                                    {item.vendorName}
                                                </option>
                                          ))
                                          : <option>No Vendor</option>
                                    }
                                </select>
                            </InputField>
                        </div>
                        <div>
                            <InputField>
                                <legend>Fee (Bank Transfer)</legend>
                                <input
                                    placeholder={'0.00'}
                                    onChange={(e) => { setGenericFee(e.target.value) }}
                                    type='number'
                                    value={genericFee}
                                />
                            </InputField>
                        </div>
                        <div>
                            <InputField>
                                <legend>Fee (USSD)</legend>
                                <input
                                    placeholder={'0.000'}
                                    onChange={(e) => { setGenericUSSDFee(e.target.value) }}
                                    type='number'
                                    value={genericUSSDFee}
                                />
                            </InputField>
                        </div>
                    </GridPaddedSpace>
                    <GridPaddedSpace>
                        <div>
                        <h3>Mongoro</h3>
                        <div>
                            <InputField>
                                <legend>Transfer Fee (Bank)</legend>
                                <input
                                    placeholder={'0.00'}
                                    onChange={(e) => { setMongoroFee(e.target.value) }}
                                    type='number'
                                    value={mongoroFee}
                                />
                            </InputField>
                        </div>
                        <div>
                            <InputField>
                                <legend>Fee (USSD)</legend>
                                <input
                                    placeholder={'0.00'}
                                    onChange={(e) => { setMongoroUSSDFee(e.target.value) }}
                                    type='number'
                                    value={mongoroUSSDFee}
                                />
                            </InputField>
                        </div>
                    </div>
                    </GridPaddedSpace>
                </BigCardsGrid>
                {mode === 'edit' && active === 'collection'
                  ? <FlexedBtn
                    style={{
                      margin: '0rem 0 1rem 0',
                      gap: '5px'
                    }}
                >
                    <button
                        style={{ cursor: 'pointer' }}
                        onClick={() => { editModel() }}
                    >
                            {onProcess ? <ClipLoader color='#fff' /> : 'Save Changes'}
                    </button>
                </FlexedBtn>
                  : <FlexedBtn
                    style={{
                      margin: '0rem 0 1rem 0',
                      gap: '5px'
                    }}
                >
                    <Link to={'/discounted-users/collection'}>
                        <button
                            style={{
                              border: '1px solid #ffab01',
                              color: '#ffab01',
                              background: 'transparent'
                            }}
                        >
                            View discounted users
                        </button>
                    </Link>
                </FlexedBtn>
                }
            </GraphCard>
            {
                success
                  ? <Alert
                        closeFunc={() => { setSuccess(false) }}
                        img='/icons/success.png'
                        message='Modified Successfully'
                        miniMessage="You have successfully modified collection model"
                    />
                  : null
            }
            {
                 error
                   ? <Alert
                        closeFunc={() => { setError('') }}
                        img='/icons/error.png'
                        message='An error occured!'
                        miniMessage={error}
                    />
                   : null
            }
        </>
  )
}

export default Collection
